import { render, staticRenderFns } from "./SettingDomainName.vue?vue&type=template&id=6598412a"
import script from "./SettingDomainName.vue?vue&type=script&lang=js"
export * from "./SettingDomainName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports